/* -------------------------------------------------------------------------- */
/*                                Checkbox styles                               */
/* -------------------------------------------------------------------------- */

@import './bq-checkbox.variables';

:host {
  @apply inline-block;
}

.bq-checkbox {
  @apply box-border inline-flex cursor-pointer select-none rounded-s transition-colors duration-300 ease-in-out p-b-xs p-i-xs;

  // Default hover state
  &:not(.is-checked),
  &:not(.is-indeterminate) {
    &:not(.is-disabled):hover .bq-checkbox__checkbox {
      @apply border-hover-brand;
    }
  }

  // Display background on hover (if enabled)
  &.has-background:not(.is-disabled):hover {
    @apply bg-hover-ui-primary;
  }

  // Checked/Indeterminate hover state
  &.is-checked,
  &.is-indeterminate {
    &:not(.is-disabled):hover .bq-checkbox__checkbox {
      @apply bg-hover-ui-brand border-hover-brand;
    }
  }
}

.bq-checkbox__input {
  // Checkbox square icon has `FOCUS`
  &:focus,
  &:focus-visible {
    ~ .bq-checkbox__checkbox {
      @apply focus border-brand;
    }
  }

  // Checkbox square icon is `CHECKED/INDETERMINATE`
  &:checked,
  &:indeterminate {
    ~ .bq-checkbox__checkbox {
      @apply border-brand bg-ui-brand;
    }
  }

  // Checkbox square icon is `CHECKED/INDETERMINATE` and `DISABLED`
  &:checked:disabled,
  &:indeterminate:disabled {
    ~ .bq-checkbox__checkbox {
      @apply opacity-60;
    }
  }

  &:disabled {
    ~ .bq-checkbox__checkbox {
      @apply opacity-60;
    }
  }
}

// Checkbox square icon `DEFAULT` state (not checked/indeterminate, not hover, not disabled)
.bq-checkbox__checkbox {
  @apply rounded-[--bq-checkbox--border-radius] border-[length:--bq-checkbox--border-width] border-solid border-[color:--bq-icon--primary];
}

.bq-checkbox__checkbox,
.bq-checkbox__label {
  @apply transition-[color,background-color,border-color,box-shadow] duration-300;
}
